import React, { useMemo } from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";

const ProcedimientosIngresoDetalle = (props) => {
  const { formCierreCuentasData } = props;
  const procedimientos = formCierreCuentasData?.procedimientos || [];

  // === Totales con useMemo ===
  const { totalLimite, totalReclamado, totalAutorizado, totalDiferencia } = useMemo(() => {
    return procedimientos.reduce(
      (acc, it) => {
        const toNum = (v) => {
          const n =
            typeof v === "string" ? Number(v.replace?.(/[, ]/g, "")) : Number(v);
          return Number.isFinite(n) ? n : 0;
        };
        acc.totalLimite += toNum(it.limiteContrato);
        acc.totalReclamado += toNum(it.montoReclamado);
        acc.totalAutorizado += toNum(it.montoAutorizado);
        acc.totalDiferencia += toNum(it.montoDiferencia);
        return acc;
      },
      { totalLimite: 0, totalReclamado: 0, totalAutorizado: 0, totalDiferencia: 0 }
    );
  }, [procedimientos]);

  // Asignar IDs: primera fila sin ID, desde la segunda empieza en 1
  const dataConIds = useMemo(() => {
    return procedimientos.map((item, index) => ({
      ...item,
      id: index === 0 ? "" : index, // 👈 primera fila vacía, segunda fila = 1
    }));
  }, [procedimientos]);

  // Fila de totales
  const totalRow = useMemo(
    () => ({
      __isTotal: true,
      id: "Totales",
      limiteContrato: totalLimite,
      montoReclamado: totalReclamado,
      montoAutorizado: totalAutorizado,
      montoDiferencia: totalDiferencia,
    }),
    [totalLimite, totalReclamado, totalAutorizado, totalDiferencia]
  );

  const dataConTotales = useMemo(
    () => [...dataConIds, totalRow],
    [dataConIds, totalRow]
  );

  const columnasProcedimientos = [
    {
      key: "id",
      title: "ID",
      dataIndex: "id",
      render: (text, item) => {
        if (text === "") return ""; // primera fila sin ID
        return <strong>{text}</strong>; // todos los demás en negrita
      },
    },
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
    },
    {
      key: "tipoReclamante",
      title: "Tipo reclamante",
      dataIndex: "tipoReclamante",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
    {
      key: "codigoReclamante",
      title: "Código reclamante",
      dataIndex: "codigoReclamante",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
    {
      key: "nombreReclamante",
      title: "Reclamante",
      dataIndex: "nombreReclamante",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
    {
      key: "limiteContrato",
      title: "Límite contrato",
      dataIndex: "limiteContrato",
      render: (text, item) => {
        const contenido = formatearMontoPesos(String(text));
        return item?.__isTotal ? <strong>{contenido}</strong> : contenido;
      },
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
    {
      key: "montoReclamado",
      title: "Monto reclamado",
      dataIndex: "montoReclamado",
      render: (text, item) => {
        const contenido = formatearMontoPesos(String(text));
        return item?.__isTotal ? <strong>{contenido}</strong> : contenido;
      },
    },
    {
      key: "montoAutorizado",
      title: "Monto a pagar ARS",
      dataIndex: "montoAutorizado",
      render: (text, item) => {
        const contenido = formatearMontoPesos(String(text));
        return item?.__isTotal ? <strong>{contenido}</strong> : contenido;
      },
    },
    {
      key: "montoDiferencia",
      title: "Diferencia no cubierta",
      dataIndex: "montoDiferencia",
      render: (text, item) => {
        const contenido = formatearMontoPesos(String(text));
        return item?.__isTotal ? <strong>{contenido}</strong> : contenido;
      },
    },
    {
      key: "coaseguro",
      title: "% coaseguro",
      dataIndex: "coaseguro",
      render: (text, item) => (item?.__isTotal ? "" : text),
    },
  ];

  return (
    <CustomTable
      columns={columnasProcedimientos}
      dataSource={dataConTotales}
      showPagination={false}
      pageSize={100}
      width={"200%"}
      maxWidth={"1400px"}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  eliminarProcedimientoCierreCuentas:
    IngresoActions.eliminarProcedimientoCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosIngresoDetalle);
